export const Page = Object.freeze({
    home: 'home',
    city: 'city',
    destination: 'destination',
    event: 'event',
    airport: 'airport',
    category: 'category',
    notFound: 'not_found',
    redirect: 'redirect',

    isSearch(page) {
        return [this.city, this.destination, this.event, this.airport].includes(
            page
        );
    },

    getPageType(page) {
        switch (page) {
            case this.event:
                return this.destination;
            case this.city:
            case this.destination:
            case this.airport:
            case this.category:
                return page;
            case this.notFound:
            case this.redirect:
            default:
                return null;
        }
    },

    fromState(page, state) {
        switch (page) {
            case this.city:
                return state.city;
            case this.airport:
            case this.destination:
            case this.event:
                return state.destination;
            case this.category:
            case this.notFound:
            case this.home:
            default:
                return null;
        }
    },
});
